import { createSwrKeyedStore } from './swr/createSwrKeyedStore';
import { getCharacter } from '../lib/api';

const swr = createSwrKeyedStore({
  name: 'CharacterDetailsStore',
  storageKey: 'bookthing-character-details',
  fetcher: async (id) => {
    const resp = await getCharacter(id);
    return resp.character || null;
  },
});

export const useCharacterDetailsStore = swr.useStore;
export const useCharacterDetail = swr.useEntry;
export const fetchCharacterDetailIfStale = swr.fetchIfStale;
